import { useEffect, useState } from "react";
import api from "@/lib/api";
import { tempoDesde } from "@/lib/constants";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { downloadProtected } from "@/components/ImportDialog";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { History, Search, FileDown } from "lucide-react";

const ENTIDADES = [
  { v: "all", label: "Todas as entidades" },
  { v: "atendimento", label: "Pedidos" },
  { v: "cliente", label: "Clientes" },
  { v: "veiculo", label: "Veículos" },
  { v: "artigo", label: "Artigos" },
  { v: "fornecedor", label: "Fornecedores" },
];

const TIPO_CLS = {
  criado: "bg-emerald-100 text-emerald-700",
  atualizado: "bg-sky-100 text-sky-700",
  estado_linha: "bg-amber-100 text-amber-700",
  uniao: "bg-violet-100 text-violet-700",
  unido: "bg-slate-200 text-slate-600",
  substituicao: "bg-rose-100 text-rose-700",
  encomenda: "bg-indigo-100 text-indigo-700",
};

export default function Historicos() {
  const [eventos, setEventos] = useState([]);
  const [users, setUsers] = useState([]);
  const [entidade, setEntidade] = useState("all");
  const [userId, setUserId] = useState("all");
  const [q, setQ] = useState("");

  const load = () => {
    const params = {};
    if (entidade !== "all") params.entity_type = entidade;
    if (userId !== "all") params.user_id = userId;
    if (q) params.q = q;
    api.get("/eventos", { params }).then((r) => setEventos(r.data));
  };

  useEffect(() => { api.get("/users").then((r) => setUsers(r.data)); }, []);
  useEffect(() => { const t = setTimeout(load, 200); return () => clearTimeout(t); /* eslint-disable-next-line */ }, [entidade, userId, q]);

  const exportPdf = () => {
    const p = new URLSearchParams();
    if (entidade !== "all") p.set("entity_type", entidade);
    if (userId !== "all") p.set("user_id", userId);
    if (q) p.set("q", q);
    p.set("titulo", "Histórico filtrado");
    downloadProtected(`/export/historico/pdf?${p.toString()}`, "historico_atlas.pdf");
  };

  return (
    <div className="max-w-5xl mx-auto">
      <h1 className="text-xl font-bold text-slate-900 mb-1 flex items-center gap-2"><History size={20} /> Históricos</h1>
      <p className="text-sm text-slate-500 mb-4">Registo auditável de todas as atividades. Filtre por entidade, utilizador ou texto.</p>

      <div className="flex flex-wrap gap-2 mb-4">
        <Select value={entidade} onValueChange={setEntidade}>
          <SelectTrigger className="w-48 h-9" data-testid="hist-filtro-entidade"><SelectValue /></SelectTrigger>
          <SelectContent>{ENTIDADES.map((e) => <SelectItem key={e.v} value={e.v}>{e.label}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={userId} onValueChange={setUserId}>
          <SelectTrigger className="w-48 h-9" data-testid="hist-filtro-utilizador"><SelectValue placeholder="Utilizador" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos os utilizadores</SelectItem>
            {users.map((u) => <SelectItem key={u.id} value={u.id}>{u.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <div className="relative flex-1 min-w-48 max-w-sm">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Pesquisar no histórico…" className="pl-9 h-9" data-testid="hist-pesquisa" />
        </div>
        <Button variant="outline" className="h-9 gap-1.5" data-testid="btn-export-pdf" onClick={exportPdf}><FileDown size={15} /> Exportar PDF</Button>
      </div>

      <div className="bg-white rounded-lg border border-slate-200 shadow-sm divide-y divide-slate-100">
        {eventos.map((e) => (
          <div key={e.id} className="flex items-start gap-3 px-4 py-2.5" data-testid={`evento-${e.id}`}>
            <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium shrink-0 mt-0.5 ${TIPO_CLS[e.tipo] || "bg-slate-100 text-slate-600"}`}>{e.tipo}</span>
            <div className="flex-1 min-w-0">
              <div className="text-sm text-slate-800">{e.descricao}</div>
              <div className="text-[11px] text-slate-400">{e.entity_type} · {e.user_name || "—"}</div>
            </div>
            <div className="text-[11px] text-slate-400 shrink-0 whitespace-nowrap">{tempoDesde(e.created_at)}</div>
          </div>
        ))}
        {!eventos.length && <div className="text-sm text-slate-400 text-center py-10">Sem registos para este filtro.</div>}
      </div>
    </div>
  );
}
